import {
  DEVICE_SUMMARY_FETCH,
  DEVICE_SUMMARY_FETCH_SUCCESS,
  DEVICE_SUMMARY_FETCH_FAIL,
  DEVICE_FETCH,
  DEVICE_FETCH_SUCCESS,
  DEVICE_FETCH_FAIL,
  MACHINE_TYPE_FETCH,
  MACHINE_TYPE_FETCH_SUCCESS,
  MACHINE_TYPE_FETCH_FAIL,
  CREATE_NEW_MACHINE,
  CREATE_NEW_MACHINE_SUCCESS,
  CREATE_NEW_MACHINE_FAIL,
  UPDATE_DEVICE_PROFILE,
  UPDATE_DEVICE_PROFILE_SUCCESS,
  UPDATE_DEVICE_PROFILE_FAIL,
  DEVICE_DETAIL_FETCH,
  DEVICE_DETAIL_FETCH_SUCCESS,
  DEVICE_DETAIL_FETCH_FAIL,
  MENU_FETCH,
  MENU_FETCH_SUCCESS,
  MENU_FETCH_FAIL,
} from '../actions';

const INIT_STATE = {
    saveMachineLoading: false,
    saveMacineError: '',
    deviceSummary: 0,
    device: '',
    machineType: '',
    machine:'',
    profile: '',
    updateDeviceProfileLoding: false,
    updateDeviceProfileerror: '',
    saveType: '',
    deviceDetail: ''
};

export default (state = INIT_STATE, action) => {
  // console.log("action type : ", action.type)
  // console.log("action : ", action.payload)
    switch (action.type) {
        case DEVICE_SUMMARY_FETCH:
            return { ...state, loading: true, error: ''};
        case DEVICE_SUMMARY_FETCH_SUCCESS:
            return { ...state, loading: false, deviceSummary: action.payload.deviceSummary, error: ''};
        case DEVICE_SUMMARY_FETCH_FAIL:
            return { ...state, loading: false, deviceSummary: 0, error: action.payload.message };

        case DEVICE_FETCH:
            return { ...state, loading: true, error: ''};
        case DEVICE_FETCH_SUCCESS:
            return { ...state, loading: false, device: action.payload.device, error: ''};
        case DEVICE_FETCH_FAIL:
				return { ...state, loading: false, device: 0, error: action.payload.message };

    		case MENU_FETCH:
    			return { ...state, loading: true, error: ''};
    		case MENU_FETCH_SUCCESS:
    			return { ...state, loading: false, menu: action.payload.menu, error: ''};
    		case MENU_FETCH_FAIL:
    			return { ...state, loading: false, menu: 0, error: action.payload.message };

        case MACHINE_TYPE_FETCH:
            return { ...state, loading: true, error: ''};
        case MACHINE_TYPE_FETCH_SUCCESS:
            return { ...state, loading: false, machineType: action.payload.machineType, error: ''};
        case MACHINE_TYPE_FETCH_FAIL:
            return { ...state, loading: false, machineType: '', error: action.payload.message };

        case CREATE_NEW_MACHINE:
            return { ...state, saveMachineLoading: true, saveMacineError: '', saveType: ''};
        case CREATE_NEW_MACHINE_SUCCESS:
            return { ...state, saveMachineLoading: false, machineCreate: action.payload.machineCreate, saveMacineError: ''};
        case CREATE_NEW_MACHINE_FAIL:
            return { ...state, saveMachineLoading: false, machineCreate: '', saveMacineError: action.payload.message };

        case UPDATE_DEVICE_PROFILE:
            return { ...state, saveMachineLoading: true, updateDeviceProfileerror: ''};
        case UPDATE_DEVICE_PROFILE_SUCCESS:
            return { ...state, saveMachineLoading: false, profile: action.payload.Message, updateDeviceProfileerror: ''};
        case UPDATE_DEVICE_PROFILE_FAIL:
            return { ...state, saveMachineLoading: false, profile: '', updateDeviceProfileerror: action.payload.message };

        case DEVICE_DETAIL_FETCH:
            return { ...state, loading: true, error: ''};
        case DEVICE_DETAIL_FETCH_SUCCESS:
            return { ...state, loading: false, deviceDetail: action.payload.deviceDetail, error: ''};
        case DEVICE_DETAIL_FETCH_FAIL:
            return { ...state, loading: false, deviceDetail: '', error: action.payload.message };

        default: return { ...state };
    }
}
